import { MapInteractionContext } from "context/MapInteractionContext";
import { useContext } from "react";

export const useMapInteractionContext = () => useContext(MapInteractionContext);
